import Vue from "vue";
import ToastComponent from "@/components/ToastComponent.vue"; // 確保這個組件存在

const ToastConstructor = Vue.extend(ToastComponent);

function showToast(message, type = "success", timeout = 5000) {
  const toastInstance = new ToastConstructor({
    propsData: { type, timeout, message }, // 用 propsData 傳遞 type 和 timeout
    data() {
      return { show: true }; // 只在 data 裡定義 message 和 show
    },
  });


  const vm = toastInstance.$mount();
  document.body.appendChild(vm.$el);

  setTimeout(() => {
    vm.show = false;
    setTimeout(() => {
      document.body.removeChild(vm.$el);
      toastInstance.$destroy();
    }, 300);
  }, timeout);
}

const ToastPlugin = {
  install(Vue) {
    Vue.prototype.$toast = showToast;

    // 添加快捷方法
    Vue.prototype.$toast.success = (message, timeout = 5000) => showToast(message, "success", timeout);
    Vue.prototype.$toast.error = (message, timeout = 5000) => showToast(message, "error", timeout);
    Vue.prototype.$toast.warning = (message, timeout = 5000) => showToast(message, "warning", timeout);
    Vue.prototype.$toast.info = (message, timeout = 5000) => showToast(message, "info", timeout);
  },
};

Vue.use(ToastPlugin);
export default ToastPlugin;
